module.exports = __webpack_public_path__ + "img/Group-32715-1-2.407778c7.png";